import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  showPassword: boolean;
};

export const SwitchPassword: FC<Props> = ({ onClick, showPassword }) => (
  <div className="modal__clear__container" style={{ lineHeight: '1em' }}>
    <button
      type="button"
      className="modal__clear"
      onClick={onClick}
      data-test-id="reveal-password"
    >
      {showPassword && (
        <span>
          <FormattedMessage id="login/components/switch-password/SwitchPassword.tsx/1" />
        </span>
      )}
      {!showPassword && (
        <span>
          <FormattedMessage id="login/components/switch-password/SwitchPassword.tsx/2" />
        </span>
      )}
    </button>
  </div>
);
